// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.DOWNLOAD_MODAL

export const DOWNLOAD_MODAL = {
  VIEWED_MODAL: 'download-viewed_modal',
  DOWNLOAD_REWARD: 'reward-download'
};
